export const PLAYER_A_CARD_HAND = 'Player A';
export const PLAYER_B_CARD_HAND = 'Player B';

export const MAX_CARDS_NUMBER = 6;
